module.exports = __webpack_public_path__ + "./angie-illustration_dd0ab05cf342d68f2251f8026e2faa4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2015/angie-illustration.png
// module id = 416
// module chunks = 0